import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { fetchDataRead } from "../../Utility";
import DataTable from "react-data-table-component";

function AddExamschedule() {
  const routeLocation = useLocation();
  const [editId, setEditId] = useState(null);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [exams, setExams] = useState([]);
  const [academic, setAcademic] = useState([]);
  const [examDates, setExamDates] = useState({});
  const userData = sessionStorage.getItem("user");
  const userObj = userData ? JSON.parse(userData) : {};
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [originalScheduleData, setOriginalScheduleData] = useState([]);
  const [form, setForm] = useState({
    exam_id: "",
    subject_id: 0,
    class_id: 0,
    exam_date: "",
    academic_year_id: 0,
    school_id: 0,
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    fetchDataRead("/classes/", setClasses, userObj.school_id);
    fetchDataRead("/exammaster", setExams, userObj.school_id);
    fetchDataRead(
      "/AcademicYear/",
      (data) => {
        setAcademic(data);
        if (data?.length > 0) {
          setForm((prevForm) => ({
            ...prevForm,
            academic_year_id: data[0]?.academic_year_id,
          }));
        }
      },
      userObj.school_id
    );
  }, []);

  // 🔹 Get ALL ACTIVE & UNIQUE subjects for a class (from teacherssubjectsmap)
  const fetchSubjects = async (class_id, academic_year_id) => {
    if (!class_id || !academic_year_id) return;
    try {
      const response = await axios.post(`${baseUrl}/teacherssubjectsmap/`, {
        action: "FILTER",
        school_id: userObj.school_id,
        class_id,
        academic_year_id,
      });

      if (response.data && Array.isArray(response.data)) {
        // 1) Only active subjects
        const activeSubs = response.data.filter(
          (sub) => sub.is_active === "Active"
        );

        // 2) Unique by subject_id (avoid duplicates for multiple teachers)
        const uniqueSubsMap = new Map();
        activeSubs.forEach((sub) => {
          if (!uniqueSubsMap.has(sub.subject_id)) {
            uniqueSubsMap.set(sub.subject_id, sub);
          }
        });
        const uniqueSubs = Array.from(uniqueSubsMap.values());

        // 3) Base subject list; max_marks & exam_date will be merged later
        const subjectList = uniqueSubs.map((sub) => ({
          subject_id: sub.subject_id,
          subject_name: sub.subject_name,
          max_marks: sub.max_marks || "",
        }));
        setSubjects(subjectList);
      } else {
        setSubjects([]);
        toast.warning("No subjects found for this class");
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      toast.error("Failed to load subjects. Please try again.");
    }
  };

  // 🔹 Get existing schedule (for edit or if already created)
  const fetchExistingSchedule = async (exam_id, class_id, academic_year_id) => {
    if (!exam_id || !class_id || !academic_year_id) return;

    try {
      const response = await axios.post(`${baseUrl}/examschedule/`, {
        exam_id,
        class_id,
        academic_year_id: userObj.academic_year_id,
        school_id: userObj.school_id,
        action: "FILTER",
      });

      // ✅ Always treat only ACTIVE rows as "existing schedule"
      const allRows = Array.isArray(response.data) ? response.data : [];
      const scheduleRows = allRows.filter(
        (item) => item.is_active === "Active"
      );

      if (scheduleRows.length > 0) {
        setOriginalScheduleData(scheduleRows);
        setEditId(scheduleRows[0]?.exam_schedule_id || null);

        // Build examDates map from ACTIVE rows only
        const dates = {};
        const dateList = [];
        scheduleRows.forEach((item) => {
          if (item.subject_id && item.exam_date) {
            dates[item.subject_id] = item.exam_date;
            dateList.push(item.exam_date);
          }
        });

        const sortedDates = dateList.sort((a, b) => new Date(a) - new Date(b));
        const startDate = sortedDates[0] || "";
        const endDate = sortedDates[sortedDates.length - 1] || "";

        setExamDates(dates);

        // Merge max_marks into subjects (subjects already loaded from teacherssubjectsmap)
        setSubjects((prevSubjects) =>
          prevSubjects.map((subject) => {
            const matched = scheduleRows.find(
              (item) => item.subject_id === subject.subject_id
            );
            if (matched) {
              return {
                ...subject,
                max_marks: matched.max_marks,
              };
            }
            return subject;
          })
        );

        setForm((prevForm) => ({
          ...prevForm,
          start_date: startDate,
          end_date: endDate,
        }));
      } else {
        // ✅ Only inactive rows or no rows: treat as "no existing schedule"
        setOriginalScheduleData([]);
        setEditId(null);
        setExamDates({});
      }
    } catch (error) {
      console.error("Error fetching schedule:", error);
      toast.error("Failed to load exam schedule");
    }
  };

  // 🔹 Helper: ensure subjects are loaded, then merge schedule (prevents race & keeps max_marks)
  const loadSubjectsAndSchedule = async (classId, examId, academicYearId) => {
    await fetchSubjects(classId, academicYearId);
    if (examId) {
      await fetchExistingSchedule(examId, classId, academicYearId);
    }
  };

  // 🔹 When editing via globaledit
  useEffect(() => {
    if (routeLocation.state?.userData) {
      const userData = routeLocation.state.userData;
      const valuesArray = Object.values(userData);

      if (valuesArray.length > 0) {
        const firstItem = valuesArray[0];

        // Set form base fields
        setForm((prevForm) => ({
          ...prevForm,
          exam_id: firstItem.exam_id,
          class_id: firstItem.class_id,
          academic_year_id: firstItem.academic_year_id,
          start_date: firstItem.start_date,
          end_date: firstItem.end_date,
        }));

        // Build initial examDates from passed state
        const initialExamDates = {};
        valuesArray.forEach((detail) => {
          if (detail.subject_id && detail.exam_date) {
            initialExamDates[detail.subject_id] = detail.exam_date;
          }
        });
        setExamDates(initialExamDates);

        // Save for matching during submit
        setOriginalScheduleData(valuesArray);
        setEditId(firstItem.exam_schedule_id);

        // 🔸 Load ALL subjects first, then merge existing schedule
        (async () => {
          await loadSubjectsAndSchedule(
            firstItem.class_id,
            firstItem.exam_id,
            firstItem.academic_year_id
          );
        })();
      }
    } else {
      console.warn("No userData found in location state");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeLocation]);

  // 🔹 When user changes Exam / Class / Academic year manually (non-edit mode)
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));

    if (id === "class_id") {
      const newClassId = value;
      const currentExamId = form.exam_id;
      const currentAcademicYear = form.academic_year_id || userObj.academic_year_id;

      setExamDates({});
      setOriginalScheduleData([]);
      setEditId(null);

      (async () => {
        await loadSubjectsAndSchedule(newClassId, currentExamId, currentAcademicYear);
      })();
    }

    if (id === "exam_id") {
      const newExamId = value;
      const currentClassId = form.class_id;
      const currentAcademicYear = form.academic_year_id || userObj.academic_year_id;

      if (currentClassId) {
        (async () => {
          await loadSubjectsAndSchedule(currentClassId, newExamId, currentAcademicYear);
        })();
      }
    }

    if (id === "academic_year_id") {
      const newAcademicYear = value;
      const currentClassId = form.class_id;
      const currentExamId = form.exam_id;

      if (currentClassId) {
        (async () => {
          await loadSubjectsAndSchedule(currentClassId, currentExamId, newAcademicYear);
        })();
      }
    }
  };

  // 🔹 Always recompute start/end as min/max of all selected examDates
  const handleDateChange = (subject_id, date) => {
    const updatedDates = {
      ...examDates,
      [subject_id]: date,
    };

    setExamDates(updatedDates);

    const validDates = Object.values(updatedDates)
      .filter((d) => d)
      .sort((a, b) => new Date(a) - new Date(b));

    if (validDates.length > 0) {
      const minDate = validDates[0];
      const maxDate = validDates[validDates.length - 1];

      setForm((prevForm) => ({
        ...prevForm,
        start_date: minDate,
        end_date: maxDate,
      }));
    } else {
      setForm((prevForm) => ({
        ...prevForm,
        start_date: "",
        end_date: "",
      }));
    }
  };

  const handleMaxMarksChange = (subject_id, value) => {
    const updatedSubjects = subjects.map((subject) => {
      if (subject.subject_id === subject_id) {
        return { ...subject, max_marks: value };
      }
      return subject;
    });

    setSubjects(updatedSubjects);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.start_date && form.end_date && form.end_date < form.start_date) {
      toast.warning("End Date cannot be earlier than Start Date");
      return;
    }

    const examData = subjects
      .map((subject) => {
        // ✅ Only consider ACTIVE records as "existing"
        const matched = originalScheduleData.find(
          (item) =>
            String(item.subject_id) === String(subject.subject_id) &&
            item.is_active === "Active"
        );

        const examDate = examDates[subject.subject_id];
        let maxMarks = subject.max_marks;

        // ✅ If editing and user didn't change Max Marks, keep existing value
        if (matched && (maxMarks === "" || maxMarks === null || maxMarks === undefined)) {
          maxMarks = matched.max_marks;
        }

        // ✅ For brand new rows with no Max Marks entered, default to 0
        if (!matched && (maxMarks === "" || maxMarks === null || maxMarks === undefined)) {
          maxMarks = 0;
        }

        // ✅ IMPORTANT: allow saving exam date even if Max Marks is blank (will use rules above)
        if (examDate) {
          return {
            exam_schedule_id: matched ? matched.exam_schedule_id : 0,
            exam_id: form.exam_id,
            subject_id: subject.subject_id,
            class_id: form.class_id,
            exam_date: examDate,
            academic_year_id: userObj.academic_year_id,
            school_id: userObj.school_id,
            max_marks: maxMarks,
            is_active: "",
            start_date: form.start_date,
            end_date: form.end_date,
            // ✅ If no ACTIVE match → CREATE new record
            action: matched ? "UPDATE" : "CREATE",
          };
        }
        return null;
      })
      .filter((item) => item !== null);

    if (examData.length === 0) {
      toast.warning("Please provide exam dates for at least one subject.");
      return;
    }

    try {
      await axios.post(`${baseUrl}/examschedule/bulk/`, examData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        editId !== null ? "Record updated successfully" : "Record added successfully"
      );

      setEditId(null);
      setOriginalScheduleData([]);
      setForm({
        exam_id: "",
        subject_id: 0,
        class_id: 0,
        academic_year_id: 0,
        exam_date: "",
        school_id: 0,
        start_date: "",
        end_date: "",
      });
      setExamDates({});
      setSubjects([]);
    } catch (error) {
      console.error("There was an error submitting:", error);
      toast.error(
        "Error submitting data: " + (error.message || error.response?.data?.error),
        { position: "top-right" }
      );
    }
  };

  const columns = [
    {
      name: "Subject Name",
      selector: (row) => row.subject_name,
      sortable: true,
    },
    {
      name: "Max Marks",
      selector: (row) => row.max_marks,
      cell: (row) => (
        <Form.Control
          type="number"
          value={row.max_marks || ""}
          onChange={(e) => handleMaxMarksChange(row.subject_id, e.target.value)}
          min={0}
          disabled={!subjects.length}
        />
      ),
      sortable: false,
    },
    {
      name: "Exam Date",
      cell: (row) => (
        <Form.Control
          type="date"
          value={examDates[row.subject_id] || ""}
          onChange={(e) => handleDateChange(row.subject_id, e.target.value)}
          disabled={!subjects.length}
        />
      ),
      sortable: false,
    },
  ];

  const data = subjects;

  return (
    <Container fluid>
      <div className="pageBody">
        <ToastContainer />
        <Container fluid>
          <Card>
            <Card.Body>
              <div className="">
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12}>
                      <h6 className="commonSectionTitle">Exam Schedule Details</h6>
                    </Col>
                  </Row>
                  <Row className="d-flex align-items-center">
                    <Col xs={12} md={2} className="mb-3">
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            Academic Year
                            <span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            id="academic_year_id"
                            value={form.academic_year_id}
                            onChange={handleInputChange}
                          >
                            <option value="0" disabled hidden>
                              {userObj.academic_year_name}
                            </option>
                            {(academic || []).map((aca) => (
                              <option
                                key={aca.academic_year_id}
                                value={aca.academic_year_id}
                              >
                                {aca.academic_year_name}
                              </option>
                            ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={2} className="mb-3">
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            Exam<span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Select
                            required
                            id="exam_id"
                            value={form.exam_id || ""}
                            onChange={handleInputChange}
                          >
                            <option value="" disabled hidden>Select Exam</option>
                            {exams
                              .filter((exam) => exam.is_active === "Active")
                              .map((exam) => (
                                <option key={exam.exam_id} value={exam.exam_id}>
                                  {exam.exam_name}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={2} className="mb-3">
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            Class
                            <span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Select
                            id="class_id"
                            value={form.class_id || ""}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="" disabled hidden>Select Class</option>
                            {classes
                              .filter((classItem) => classItem.is_active === "Active")
                              .map((classItem) => (
                                <option
                                  key={classItem.class_id}
                                  value={classItem.class_id}
                                >
                                  {classItem.class_name}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={2} className="mb-3">
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            Start Date <span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            id="start_date"
                            value={form.start_date || ""}
                            placeholder="Select Start Date"
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                    <Col xs={12} md={2} className="mb-3">
                      <div className="commonInput">
                        <Form.Group>
                          <Form.Label>
                            End Date <span className="requiredStar">*</span>
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            id="end_date"
                            value={form.end_date || ""}
                            placeholder="Select End Date"
                            onChange={handleInputChange}
                            min={form.start_date || ""}
                          />
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>

                  <div
                    style={{
                      maxHeight: "400px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                      backgroundColor: "#fff",
                      padding: "10px",
                      margin: "10px auto 0 auto",
                      width: "100%",
                      maxWidth: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <DataTable
                      className="custom-table table-height-300px"
                      columns={columns}
                      data={
                        data.length > 0
                          ? data
                          : [{ subject_name: "No records found", exam_date: "" }]
                      }
                      highlightOnHover
                      responsive
                      fixedHeader
                      fixedHeaderScrollHeight="300px"
                      noDataComponent="No subjects found"
                      conditionalRowStyles={[
                        {
                          when: (row) => row.subject_name === "No records found",
                          style: {
                            textAlign: "center",
                            fontSize: "16px",
                            color: "red",
                            backgroundColor: "#f9f9f9",
                          },
                        },
                      ]}
                    />
                  </div>

                  <div className="d-flex justify-content-between mt-3">
                    <div>
                      <Button
                        type="button"
                        className="btn btn-info clearBtn"
                        onClick={() => {
                          setForm({
                            exam_id: "",
                            subject_id: "",
                            class_id: "",
                            academic_year_id: "",
                            exam_date: "",
                            school_id: "",
                            start_date: "",
                            end_date: "",
                          });
                          setSubjects([]);
                          setExamDates({});
                          setOriginalScheduleData([]);
                          setEditId(null);
                        }}
                      >
                        Reset
                      </Button>
                    </div>
                    <div>
                      <Button
                        type="button"
                        variant="primary"
                        className="btn-danger secondaryBtn"
                        onClick={() => window.history.back()}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="success"
                        className="btn btn-success primaryBtn"
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </Container>
  );
}

export default AddExamschedule;
